import * as React from 'react';
import {TextField} from '@sail/ui';

export const Invalid = () => (
  <TextField label="Current year" defaultValue="1892" invalid />
);
